module.exports = __webpack_public_path__ + "img/SDG-02-EN-INVERTED.98cc691c.png";